<template>
  <div class="plots" id="million-bit-plots">
    
    <h2 class="mb-4 honk-text">My Plots</h2>
    <p v-if="!appData().connectedAccount.address">Connect your wallet to view your plots</p>

    <div v-if="nfts.length > 0">
        <div v-for="(nft, index) in nfts" :key="nft.tokenId" class="nft-card">
            <!-- <p>Token ID: {{ nft.tokenId }}</p> -->
            <img :src="nft.image" alt="NFT Image" class="plot-nft" :ref="'cardImage-'+index" />
            <canvas 
                :ref="'canvas-' + index" 
                :width="nft.width" 
                :height="nft.height"
            ></canvas>
            <p>
                <!-- Hidden File Input to pick an image -->
                <input 
                type="file" 
                ref="fileInputs"
                :ref="'fileInput-' + index" 
                @change="onFileChange($event, index, nft)" 
                accept="image/*" 
                style="display: none;" 
                />

                <!-- URL text input -->
                <div v-if="nft.showForm" class="">
                    <input type="text" v-model="nft.link" placeholder="Enter the URL of the new image" class="form-control form-control-md mb-2" />
                    <button v-on:click="submitNewImage(index, nft)" class="btn btn-warning btn-block mb-4" v-bind:disabled="nft.isLoading">SAVE</button>
                    <div class="loader" v-if="nft.isLoading"></div>
                </div>
                <div class="btn-group btn-block">
                    <a v-bind:href="'https://magiceden.us/item-details/base/'+contractAddress+'/'+nft.tokenId" target="_blank" class="btn btn-outline-primary">Marketplace</a>
                    <a @click.prevent="repaint(index, nft)" href="#" target="_blank" class="btn btn-outline-primary">Repaint</a>
                </div>
                <ul class="p-0">
                    <li v-for="(value, key) in nft.attributes" :key="key" v-if="value.trait_type !== 'X1' && value.trait_type !== 'Y1' && value.trait_type !== 'X2' && value.trait_type !== 'Y2'">
                        <strong>{{ value.trait_type }}:</strong> {{ value.value }}
                    </li>
                </ul>
            </p>
            <hr />
        </div>
    </div>
    <div v-else>
        <div>
            <p>Connect your wallet to see your plot NFTs here. Then you can repaint your pixels 👩‍🎨</p>
            <button class="btn btn-primary" v-on:click="getNFTs">Refresh</button>
            <div v-if="nftsLoading">
                <span>Loading...</span>
            </div>
        </div>
    </div>

    <b-modal id="modal-repaint-success" title="You're a part of onchain history!" hide-footer size="lg">
      <p>
        Your repainted plot has been submitted. <a v-if="trxHashSuccess" v-bind:href="'https://basescan.org/tx/'+trxHashSuccess" target="_blank">View transaction</a>
        <br />
        Please allow a few minutes for the transaction to be confirmed.
      </p>
    </b-modal>
  </div>
</template>

<script>
import utils from '../utils';
import config from '../config';

export default {
  name: 'plots',
  data () {
    return {
        contractAddress: config.NFT_CA,
        nftsLoading: true,
        nfts: [],
        repaintPrice: undefined,
        trxHashSuccess: undefined,
    }
  },
  computed: {
  },
  methods: {
    navigateTo: function(route) {
      this.$router.push(route);
    },
    repaint: function(index, nft) {
        console.log('Repainting NFT', nft);
        this.$refs[`fileInput-${index}`][0].click();
    },
    onFileChange(event, index, nft) {
        nft.showForm = true;
        console.log('File changed', index, nft);
        // return (event) => {
            console.log('File changed event', event);
            // Get the selected file
            const file = event.target.files[0];
            console.log('File', file);
            if (file && file.type.startsWith('image/')) {
                // Create a FileReader to read the image
                const reader = new FileReader();
                reader.onload = (e) => {
                    console.log('File reader loaded', e);
                    // Create a new image element
                    const img = new Image();
                    img.onload = () => {
                        // Get the canvas context and draw the image
                        const canvas = this.$refs[`canvas-${index}`][0];
                        const ctx = canvas.getContext('2d');
                        
                        // Clear the canvas before drawing a new image
                        ctx.clearRect(0, 0, nft.width, nft.height);
                        
                        // Draw the image onto the canvas
                        ctx.drawImage(img, 0, 0, nft.width, nft.height);

                        // Place the canvas over the card image
                        const cardImage = this.$refs[`cardImage-${index}`][0];
                        const cardImageWidth = cardImage.width;
                        const imgRatio = cardImageWidth / 128;
                        canvas.style.width = nft.width * imgRatio + 'px';
                        canvas.style.height = nft.height * imgRatio + 'px';
                        canvas.style.top = (((128 / 2) + 16 - (nft.height / 2)) * imgRatio) + 'px'; // (((144 * imgRatio)) / 2) + (17 * imgRatio) - ((nft.height * imgRatio)) + 'px';
                        canvas.style.left = (((128 * imgRatio)) / 2) - ((nft.width * imgRatio) / 2) + 'px';
                    };
                    // Set the source of the image element to the file data
                    img.src = e.target.result;
                };
                // Read the image file as a data URL
                reader.readAsDataURL(file);
            }
        // };
    },
    async getRepaintPrice() {
        console.log('Getting repaint price');
        const { provider } = await this.getProviderSigner();
        const contract = new ethers.Contract(this.contractAddress, config.NFT_ABI, provider);
        const price = await contract.repaintPrice();
        console.log('Repaint price', price);
        this.repaintPrice = price;
        return price;
    },
    // Get the NFTs owned by the connected wallet
    async getNFTs() {
        this.nftsLoading = true;
        try {
        const userAddress = this.appData().connectedAccount.address;
        let { provider, signer } = await this.getProviderSigner();
      const contract = new ethers.Contract(this.contractAddress, config.NFT_ABI, signer);

      // Get the user's balance of NFTs
      const balance = await contract.balanceOf(userAddress);
      const nftData = [];

      // Loop through each token the user owns
      for (let i = 0; i < balance; i++) {
        const tokenId = await contract.tokenOfOwnerByIndex(userAddress, i);

        let nft = {
            showForm: false,
            canBuy: false,
            tokenId: tokenId.toString(),
            isLoading: false,
        }

        // Fetch the metadata for each token (assuming it uses tokenURI)
        const tokenURI = await contract.tokenURI(tokenId);

        try {
            // Fetch the metadata from the tokenURI (typically JSON hosted on IPFS or other storage)
            const metadata = await fetch(tokenURI).then((response) => response.json());

            const nftLink = metadata.attributes.find((attr) => attr.trait_type === 'Link').value;
            const nftCoordinates = metadata.attributes.find((attr) => attr.trait_type === 'Coordinates').value;
            const nftCoords = nftCoordinates.split(' to ');
            const nftXY1 = nftCoords[0].substring(1, nftCoords[0].length-1).split(',');
            const nftXY2 = nftCoords[1].substring(1, nftCoords[1].length-1).split(',');
            const nftWidth = parseInt(nftXY2[0]) - parseInt(nftXY1[0]);
            const nftHeight = parseInt(nftXY2[1]) - parseInt(nftXY1[1]);
            
            nftData.push({
                ...nft,
                width: nftWidth,
                height: nftHeight,
                x1: parseInt(nftXY1[0]),
                y1: parseInt(nftXY1[1]),
                link: nftLink,
                ...metadata,
            });
        } catch(e) {
            console.log(`Error fetching metadata for token ${tokenId}`, e);
            nftData.push(nft);
            this.nftsLoading = false;
        }
      }

      // Set the NFTs in the component's state
      this.nfts = nftData;
      this.nftsLoading = false;
        } catch(e) {
            console.error('Error getting NFTs', e);
            this.nftsLoading = false;
        }
    },
    async submitNewImage(index, nft) {
        console.log('Submitting new image');
        await this.getRepaintPrice();
        const { provider, signer } = await this.getProviderSigner();
        const contract = new ethers.Contract(this.contractAddress, config.NFT_ABI, signer);

        const canvas = this.$refs[`canvas-${index}`][0];
        const ctx = canvas.getContext('2d');

        const imageData = ctx.getImageData(0, 0, nft.width, nft.height).data;
        const pixels_data = utils.getPixelsData(imageData, nft.width, nft.height);

        let pixels_data_strs = [];
        _.times(nft.height/16, function(h){
            _.times(nft.width/16, function(w){
                pixels_data_strs.push(utils.stringDataForEth(pixels_data[h][w], nft.link, 0, h, w, nft.x1, nft.y1));
            });
        });
        
        console.log('pixels_data_strs', pixels_data_strs)
        var pixels_data_str = pixels_data_strs.join('\n');
        var pixels_data_gzip_str = pako.deflate(pixels_data_str, { to: 'string' });
        
        console.log('pixels_data_str length: '+pixels_data_str.length);
        console.log('pixels_data_gzip_str length: '+pixels_data_gzip_str.length);
        console.log('compression ratio: '+(pixels_data_str.length/pixels_data_gzip_str.length));

        // console.log('New image', pixels_data_gzip_str);
        try {
            nft.isLoading = true;
            let tx;
            if (false) {
                const tokenContract = new ethers.Contract(config.TOKEN_CA, config.TOKEN_ABI, signer);
                // TODO get live value from contract
                const repaintTokenPrice = await contract.tokenRepaintPrice();
                // console.log(`Repaint token price: ${tokens}`);
                // const repaintTokenPrice = ethers.parseUnits(tokens.toString(), 18);
                console.log('Repaint token price', repaintTokenPrice);
                const approveTrx = await tokenContract.approve(config.NFT_CA, repaintTokenPrice);
                console.log(`Approved ${repaintTokenPrice} tokens for NFT contract:`, approveTrx);
                const approveReceipt = await approveTrx.wait();
                console.log('Approval receipt:', approveReceipt);
                tx = await contract.tokenRepaintPixels(nft.tokenId, pixels_data_gzip_str);
            } else {
                const estimatedGas = await contract.repaintPixels.estimateGas(nft.tokenId, pixels_data_gzip_str, {value: this.repaintPrice});
                const gasLimit = this.getGasLimitFromEstimate(estimatedGas);
        
                const overrides = {
                    gasLimit: gasLimit,
                    value: this.repaintPrice,
                };
                tx = await contract.repaintPixels(nft.tokenId, pixels_data_gzip_str, overrides);
            }
            
            console.log('Repaint transaction', tx);
            
            const receipt = await tx.wait();
            const hash = receipt.hash;
            nft.isLoading = false;

            // Show modal with success message
            this.trxHashSuccess = hash;
            this.$bvModal.show('modal-repaint-success');
            utils.confetti(10000);

            // Trigger lambda
            try {
                fetch(config.WEBHOOK_URL+'?trigger=true', {
                    method: 'GET',
                });
            } catch(e) {
            console.log('Error triggering lambda', e);
            }
        } catch(e) {
            nft.isLoading = false;

            utils.trackEvent('trxFailed');
            console.error('Error sending:', e);
            this.handleWalletError(e);
        }
    }
  },
  mounted: function () {
    if (this.appData().connectedAccount) {
        this.getNFTs();
    } else {
        this.$on('accountConnected', this.getNFTs);
    }
  },
  inject: [
    'updateAppRoute', 'appData', 'postToLambda', 'getProviderSigner',
    'handleWalletError',
    'getGasLimitFromEstimate',
  ],
  created: function () {
    this.updateAppRoute('plots');
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    #million-bit-plots {
      background: #fff !important;
      padding: 20px;
    }
    .plots ul {
        list-style: none;
    }
    .loader {
        right: -32px;
        top: 0px;
        bottom: 0px;
    }
    .nft-card {
        width: 50%;
        max-width: 500px;
        margin: 0 auto;
        position: relative;
    }
    .nft-card canvas {
        position: absolute;
    }
    img.plot-nft {
        width: 100%;
    }
    /* Mobile */
    @media screen and (max-device-width: 768px) {
        h2 {
            font-size: 4rem;
        }
        .nft-card {
            width: 80%;
            max-width: 600px;
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/Plots.vue?47932fbc